const state = {
    // 普通待付款訂單數據
    orderCreateGoodsData: "",

    //團購待付款訂單數據
    groupbuyOrderCreateData: "",

    //秒殺待付款訂單數據
    seckillOrderCreateData: "",

    //組合套餐待付款訂單數據
    comboOrderCreateData: "",
	
	//積分待付款訂單數據
	pointsOrderCreateData: "",
}

const mutations = {
    SET_ORDER_CREATE_DATA: (state, orderCreateData) => {
        state.orderCreateGoodsData = orderCreateData
    },
    SET_GROUPBUY_ORDER_CREATE_DATA: (state, groupbuyOrderCreateData) => {
        state.groupbuyOrderCreateData = groupbuyOrderCreateData
    },
    SET_SECKILL_ORDER_CREATE_DATA: (state, seckillOrderCreateData) => {
        state.seckillOrderCreateData = seckillOrderCreateData
    },
    SET_COMBO_ORDER_CREATE_DATA: (state, comboOrderCreateData) => {
        state.comboOrderCreateData = comboOrderCreateData
    },
	SET_POINTS_ORDER_CREATE_DATA: (state, pointsOrderCreateData) => {
	    state.pointsOrderCreateData = pointsOrderCreateData
	}
}

const actions = {
    setOrderCreateData({ commit, state }, data) {
        commit("SET_ORDER_CREATE_DATA", data)
    },
    removeOrderCreateData({ commit }) {
        commit("SET_ORDER_CREATE_DATA", "")
    },
    setGroupbuyOrderCreateData({ commit, state }, data) {
        commit("SET_GROUPBUY_ORDER_CREATE_DATA", data)
    },
    removeGroupbuyOrderCreateData({ commit }) {
        commit("SET_GROUPBUY_ORDER_CREATE_DATA", "")
    },

    setSeckillOrderCreateData({ commit, state }, data) {
        commit("SET_SECKILL_ORDER_CREATE_DATA", data)
    },
    removeSeckillOrderCreateData({ commit }) {
        commit("SET_SECKILL_ORDER_CREATE_DATA", "")
    },
    setComboOrderCreateData({ commit, state }, data) {
        commit("SET_COMBO_ORDER_CREATE_DATA", data)
    },
    removeComboOrderCreateData({ commit }) {
        commit("SET_COMBO_ORDER_CREATE_DATA", "")
    },
	setPointsOrderCreateData({ commit, state }, data) {
	    commit("SET_POINTS_ORDER_CREATE_DATA", data)
	},
	removePointsOrderCreateData({ commit }) {
	    commit("SET_POINTS_ORDER_CREATE_DATA", "")
	},
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
